/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-29 15:42:44
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-24 17:48:51
 * @name: 路由白名单
 * @Description: 路由白名单
 * @FilePath: \preSaleNafterSaleBackstage\src\config\whiteList.config.js
 * @Author: desktop
 */
export default [
  '/401', //无权限页面
  '/404', //不存在的页面
  '/login', //登录页
  '/forgetPassword', //忘记密码页面
  '/register', //注册页面
  '/index/welcome', //欢迎页面
  '/preSaleNafterSaleDistributorApp', //海伦易购App下载页面
  '/preSaleNafterSaleInsideApp', //海伦业务助手App下载页面
]